import type { AudienceMemberMinimal, MergedAudienceMember } from "@/types/audience-list-members.types";
import type { PasscodeListMember } from "@/types/working-model";

export const passcodeListMemberToMergedAudienceMember = (member: PasscodeListMember): MergedAudienceMember => {
	return {
		passcode_list: member.passcode_list,
		member_id: member.passcode_list_member,
		email: member.email,
		created_date: new Date(member.created_date),
		imported_profile: member.imported_profile || {},
		uses: member.uses ?? 0,
		avatar: member.avatar,
		magic_link: member.magic_link,
		internal_source: 'passcode_list_member'
	};
};

export const audienceListMemberToMergedAudienceMember = (member: AudienceMemberMinimal): MergedAudienceMember => {
	return {
		passcode_list: member.passcode_list,
		member_id: member.bl_profile,
		email: member.email,
		created_date: new Date(member.created_date),
		imported_profile: member.imported_profile || {},
		uses: member.uses ?? 0,
		avatar: member.avatar,
		magic_link: member.magic_link,
		internal_source: 'audience_list_member'
	};
};

export const mergedListMemberToAudienceMember = (member: MergedAudienceMember): AudienceMemberMinimal => {
	return {
		bl_profile: member.member_id,
		passcode_list: member.passcode_list,
		email: member.email ?? 'unknown@example.com',
		created_date: member.created_date.toISOString(),
		imported_profile: member.imported_profile,
		uses: 0,
		avatar: member.avatar,
		magic_link: member.magic_link
	};
};

export const mergedListMemberToPasscodeListMember = (member: MergedAudienceMember): PasscodeListMember => {
	return {
		passcode_list_member: member.member_id,
		passcode_list: member.passcode_list,
		email: member.email ?? 'unknown@example.com',
		created_date: member.created_date.valueOf(),
		imported_profile: member.imported_profile,
		uses: 0,
		avatar: member.avatar,
		magic_link: member.magic_link ?? undefined,
		passcode: member.deprecated_passcode ?? null
	};
};